import http from 'utils/request'
import type {
  LoginWithPasswordParams,
  SendVerificationCodeParams,
  LoginWithVerificationCodeParams,
  LoginResponse
} from './login-model'
import { ResponseModel } from "./base-model"

export function loginWithPassword(data: LoginWithPasswordParams) {
  return http.Post<ResponseModel>('/loginWithPassword', data, {
    meta: { authRole: 'login' }
  })
}

export function sendVerificationCode(data: SendVerificationCodeParams) {
  return http.Post<ResponseModel>('/sendVerificationCode', data, {
    meta: { authRole: null }
  })
}

export function loginWithVerificationCode(
  data: LoginWithVerificationCodeParams
) {
  return http.Post<ResponseModel>('/loginWithVerificationCode', data, {
    meta: { authRole: 'login' }
  })
}

export function logout() {
  return http.Get('/logout')
}

